import { FormControl, MenuItem } from "@mui/material";
import { InputLabel } from "@mui/material";
import { Control, Controller, UseFormSetValue } from "react-hook-form";
import { Select } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import CloseIcon from "@mui/icons-material/Close";

export type SelectOptionType = {
  id: string;
  name: string;
};

type SelectInputPropsType = {
  control: Control<any, any>;
  options: SelectOptionType[];
  variableName: string;
  label: string;
  errors: any;
  setValue: UseFormSetValue<any>;
  watch: any;
  defaultValue: string | number | null;
  variant?: "standard" | "outlined" | "filled";
};

export default function SelectInput(props: SelectInputPropsType) {
  const {
    control,
    setValue,
    options,
    variableName,
    label,
    errors,
    watch,
    defaultValue,
    variant,
  } = props;

  function handleClear() {
    setValue(variableName, null);
  }
  return (
    <FormControl
      fullWidth
      className="custom_select"
      variant={variant ?? "standard"}
      sx={{ height: "100%" }}
    >
      <InputLabel id="status-select-label" className="mb-2">
        {label} *
      </InputLabel>
      <Controller
        name={variableName}
        control={control}
        defaultValue=""
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              defaultValue={defaultValue}
              labelId={label}
              className="input-container"
              id={variableName}
              size="medium"
              disabled={!options?.length}
              value={value}
              onChange={onChange}
              sx={{ textAlign: "left" }}
            >
              {options.map((option, index) => (
                <MenuItem key={`option-${index}`} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
            {watch(variableName) && (
              <CloseIcon
                sx={{
                  position: "absolute",
                  right: "16px",
                  bottom: "8px",
                  height: "18px",
                }}
                onClick={handleClear}
              />
            )}
            <FormHelperText error={!!errors[variableName]}>
              {errors[variableName] ? errors[variableName].message : ""}
            </FormHelperText>
          </>
        )}
      />
    </FormControl>
  );
}
